'use strict';

var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = require('function-bind');

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);



//////////////////
// WEBPACK FOOTER
// ./~/hasown/index.js
// module id = 236
// module chunks = 0